import { useCallback } from 'react'

import { useSegment } from '../../../hooks'

export const useTrackDemoInvoiceEditor = () => {
  const { track } = useSegment()

  const trackDemoInvoiceEditor = useCallback(
    (eventDetail: string, payload?: Record<string, unknown>) => {
      track(`XXX - Invoicing Core - Demo Invoice Editor - ${eventDetail}`, payload)
    },
    [track],
  )

  return { trackDemoInvoiceEditor }
}
